<template lang="pug">
.res-detail
  .status
    notification(:status="resStatusVO.code" :msg="resStatusVO.msg" :subMsg="resStatusVO.subMsg")
  .card
    res-detail-card(:res="res")

  .btns
    ghost-btn(v-if="rescheduleable" @clicked="onReschedule" :copy="$t('reservation.btn.reschedule')")
    ghost-btn(v-if="cancelable" @clicked="onCancel" :copy="$t('reservation.btn.cancel')")
  .more
    ghost-btn(v-if="cancelable" @clicked="onMore" :copy="$t('reservation.btn.more')")
  .canceled(v-if="canceled") 钱款和积分已退回至支付宝账户
    
    //.btn.btn-reschedule(@click="onReschedule") {{$t('reservation.btn.reschedule')}}
    //.btn.btn-cancel(@click="onCancel") {{$t('reservation.btn.cancel')}}
  //.status.success(v-if="status===1" key="1")
    notification(:status="200" :msg="$t('addAdult.success[0]')")
    .name-card
  popup(v-if="showPopup" @yes="onCancelYes" @no="onCancelNo" title="是否取消预约?")
  
</template>
<script>
import AlipayService from '@/services/AlipayService'
import Notification from '@/components/wedgits/Notification'
import { mapGetters, mapMutations, mapState } from 'vuex'
import ConfirmCard from '@/components/futureshop/ConfirmCard'
import ResDetailCard from '@/components/me/ResDetailCard'
import Popup from '@/components/wedgits/Popup'
import {
  getResStatus,
  getResVOStatus,
  RES_SCHEDULE_STATUS,
  RES_STATUS,
} from '@/helpers/ResHelper'
import GhostBtn from '@/components/wedgits/GhostBtn'
export default {
  name: 'ResDetail',
  components: { GhostBtn, Popup, ResDetailCard, ConfirmCard, Notification },
  props: {
    id: {},
  },
  data() {
    return {
      showPopup: false,
    }
  },
  computed: {
    //...mapGetters('app', ['getReses']),
    ...mapState('app', ['user']),
    res() {
      //return this.getReses[this.id]
      return this.user.reses.filter((r) => {
        return r.resId === this.id
      })[0]
    },
    resStatusVO() {
      return this.$t(`reservation.resStatusVO[${getResVOStatus(this.res)}]`)
    },
    cancelable() {
      return (
        this.res.resStatus === RES_STATUS.RESCHEDULED ||
        this.res.resStatus === RES_STATUS.CREATED
      )
    },
    rescheduleable() {
      return this.res.resStatus === RES_STATUS.CREATED
    },
    canceled() {
      return this.res.resStatus === RES_STATUS.CANCELED
    },
    // status() {
    //   return getResStatus(
    //     this.res.schedule.from,
    //     this.res.schedule.to,
    //     this.res.resStatus
    //   )
    //   // let now = Date.now()
    //   // let gap = this.res.schedule.from.getTime() - now
    //   // gap = gap / (1000 * 3600)
    //   // if (gap < 0) return 2
    //   // else if (gap < 2) return 1
    //   // else return 0
    // },
  },
  methods: {
    ...mapMutations('app', ['setRouterBack']),
    onMore() {
      this.setRouterBack('/')
      this.$router.replace('/reservation')
    },
    onReschedule() {
      //this.setRouterBack('/me/res')
      this.$router.replace(`/me/resReschedule?resId=${this.res.resId}`)
    },
    onCancel() {
      this.showPopup = true
    },
    onCancelYes() {
      this.showPopup = false
      //console.log(999999999999999999999999999, this.res)
      //this.setRouterBack('/me/res')
      this.$router.replace(`/me/resCancel?resId=${this.res.resId}`)
    },
    onCancelNo() {
      this.showPopup = false
    },
  },
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.res-detail
  +full
  .card
    margin-left: 0
    width: 100%
    height: pxToRem(980)
  .btns
    z-index: 99
    position: relative
    margin-top: pxToRem(-160)
    width: 100%
    display: flex
    flex-direction: row
    align-items: center
    justify-content: center
  .more
    margin-top: pxToRem(90)
    width: 100%
    display: flex
    align-items: center
    justify-content: center
  .canceled
    width: 100%
    font-size: 12px
    color: #999999
    text-align: right
    position: relative
    right: pxToRem(80)
    top: pxToRem(-100)
    //.btn
      width: pxToRem(170)
      height: pxToRem(60)
      font-size: pxToRem(30)
      color: $cl-blue
      border-radius: pxToRem(30)
      border: 1px $cl-blue solid
      text-align: center
      line-height: pxToRem(50)
      margin-right: pxToRem(40)
</style>
